import type {
  SaveUserConsentPayload,
  UserConsentResponse,
} from "./cookieConsent.types";

import { baseApi } from "@/app/api/baseApi";

export const consentApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getUserConsent: builder.query<UserConsentResponse | null, void>({
      query: () => ({
        url: "/consent/me",
        method: "GET",
        validateStatus: (response): boolean =>
          response.status === 401 ||
          (response.status >= 200 && response.status < 300),
      }),
      transformResponse: (res: { data?: UserConsentResponse | null }, meta) => {
        if (meta?.response?.status === 401) {
          return null;
        }

        return res.data ?? null;
      },
      providesTags: ["consent-me"],
    }),

    saveUserConsent: builder.mutation<
      UserConsentResponse,
      SaveUserConsentPayload
    >({
      query: (body) => ({ url: "/consent/me", method: "PUT", body }),
      transformResponse: (res: { data: UserConsentResponse }) => res.data,
      invalidatesTags: ["consent-me"],
    }),
  }),
});

export const { useGetUserConsentQuery, useSaveUserConsentMutation } =
  consentApi;
